<template>
    <div>
        <!-- <el-card>
            <el-alert title="订单送券" type="success" description="(1)订单满减送券
            (2)订单指定产品送券
            (3)订单指定品类送券
            (4)都可指定门店参与和指定门店不参与活动
            注:下完订单后会自动弹出送出的优惠券，可点击立即使用到券可以使用产品页面，进行购买下单完成，需要页面展示买那些产品可以送券">
            </el-alert>
        </el-card> -->
        <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="活动标题">
                <el-input v-model="form.name" :maxlength="50" show-word-limit style="width: 60%;"></el-input>
            </el-form-item>
            <el-form-item label="活动内容">
                <el-input type="textarea" v-model="form.desc_txt" :maxlength="300" show-word-limit
                    style="width: 60%;"></el-input>
            </el-form-item>
            <imgPicker :dialog-visible="imgDialog2" :sc-status="isGetImage2" @chooseImg="pickImg2" @closeImgDialog="closeImgDialog2"></imgPicker>
            <el-form-item label="背景图片" hide-requied-aterisk="true">

                <div @click="handleImgPicker2" class="upload-box">
                <img v-if="form.backend_img" :src="form.backend_img" class="avatar"/>
                <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
                </div>
            </el-form-item>
            <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
            <el-form-item label="分享图片" hide-requied-aterisk="true">

                <div @click="handleImgPicker" class="upload-box">
                <img v-if="form.share_img" :src="form.share_img" class="avatar"/>
                <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
                </div>
            </el-form-item>
            <el-form-item label="分享文字">
                <el-input type="textarea" v-model="form.share_desc" :maxlength="300" show-word-limit
                    style="width: 60%;"></el-input>
            </el-form-item>
            <el-form-item label="活动时间">
                <el-date-picker v-model="form.times" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="活动类型">
                <el-radio-group v-model="form.type" style="">
                    <el-radio :label="1">新客专区</el-radio>
                    <el-radio :label="2">社群专区</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否关联商品">
                <el-radio-group v-model="form.rel_items_flag" style="">
                    <el-radio :label="1">关联</el-radio>
                    <el-radio :label="0">不关联</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="次数限制">
                <el-input v-model="form.user_one_limit"  style="width: 200px;"></el-input>
                <el-tag>(每人参与次数限制,0不限制)</el-tag>
            </el-form-item>
            <el-form-item label="总人数">
                <el-input v-model="form.user_all_limit"  style="width: 200px;"></el-input>
                <el-tag>(活动总人数限制，0不限制)</el-tag>
            </el-form-item>
             <el-card style="width: 70%;">
                <div slot="header" class="clearfix">
                    <el-button @click="showCoupons" size="mini" type="primary">选择优惠券+</el-button>
                </div>
                <div v-if="sendInfo" class="text item">
                    <el-tag v-for="(item, index) in sendInfo" :key="item.id" closable type="success"
                        @close="handleClose(item)">
                        ID:{{ item.id }} : {{ item.title }}
                    </el-tag>
                </div>
            </el-card>
        
            <el-card header="绑定商品" shadow="naver">
            <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
      <el-table
        :data="form.items"
        style="line-height: normal"
      >
        <el-table-column label="ID" prop="item_id"></el-table-column>
        <el-table-column
          label="商品货号"
          prop="item_bn"
        ></el-table-column>
        <el-table-column label="名称" prop="item_name"></el-table-column>
        <el-table-column label="类型" prop="special_type">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.special_type == 'drug'"
              >处方药</span
            >
            <span style="color: blue" v-else>非处方药</span>
          </template>
        </el-table-column>
        <el-table-column label="活动价" >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.activity_price "
              min="0.01"
              onkeyup="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <i
              class="iconfont icon-trash-alt"
              @click="deleteItemRow(scope.$index, form.items)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="cancelSubmit">取消</el-button>
            </el-form-item>
        </el-form>
        <couponPicker :visible="couponsVisible" @pickCoupon="pickCoupon" @closeDialog="closeDialogs"></couponPicker>
    

    </div>
</template>
<script>
import {
    mapGetters
} from "vuex";
import imgPicker from '@/components/imageselect'
import DistributorSelect from '@/components/storeListSelect'
import SkuSelector from '@/components/function/skuSelector'
import couponPicker from '@/components/coupon_picker'
import { getItemsList } from '@/api/goods'
import draggable from "vuedraggable";
import {
  getNewCustomerRow, saveNewCustomer, editNewCustomer
} from "@/api/promotions";
export default {
    inject: ['refresh'],
    components: {
        draggable,
        SkuSelector,
        imgPicker,
        couponPicker
    },
    data() {
        return {
            couponsVisible: false,
            zdShopHidden: true,
            zdItemHidden: true,
            zdItemHidden2: true, 
            imgDialog: false,
            isGetImage: false,
            imgDialog2: false,
            isGetImage2: false,
            sendInfo:[],
            relItems:[],
            addedItems: [],
            relItemsIds: [],
            form: {
                type:1,
                name: '', 
                share_img:'',
                backend_img:'',
                share_desc:'',
                rel_items_flag:1,
                kaquan_list:'',
                times:'',
                desc_txt:'',
                user_one_limit:0,
                user_all_limit:0,
                items:[], 
            }, 
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
        cancelSubmit () {
        this.$router.go(-1)
      },
        closeImgDialog () {
          this.imgDialog = false
          this.isGetImage = false
      },
      handleImgPicker () {
          this.imgDialog = true
          this.isGetImage = true
      },
      pickImg (data) {
          this.form.share_img = data.url
      },
        closeImgDialog2 () {
          this.imgDialog2 = false
          this.isGetImage2 = false
      },
      handleImgPicker2 () {
          this.imgDialog2 = true
          this.isGetImage2 = true
      },
      pickImg2 (data) {
          this.form.backend_img = data.url
      },
      deleteItemRow: function (index, rows) {
      rows.splice(index, 1);
      this.form.items = rows;
      this.setItemStatus = false;
      this.relItemsIds.splice(index, 1);
    },
    getItems(data) {
      let arr = [];
      data.forEach((item, index) => {
        let newData = "";
        let isInArr = this.addedItems.findIndex(
          (n) => n.item_id == item.itemId
        );
        if (isInArr == -1) {
          newData = {
            item_id: item.itemId,
            item_bn: item.itemBn,
            item_name: item.itemName,
            special_type: item.special_type,
            // 默认设置活动库存 9999
            activity_price: item.price/100,
            special_type: item.special_type,
            item_spec_desc: item.item_spec_desc,
            sort: item.sort,
            limit_num: 0,
            item_type: item.item_type,
          };
        } else {
          newData = this.addedItems[index];
        }
        arr.push(newData);
      });
      this.form.items = arr;
    },
        closeDistributorDialogAction() {
            this.distributorVisible = false
        },
        goBack() {
            this.$confirm("此操作返回上一个页面, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    history.back(0);
                })
                .catch(() => { });
        },
        closeDialogs() {
            console.log('close_coupons')
            this.couponsVisible = false;
        },
        pickCoupon(data) {
            this.couponsVisible = false
            this.sendInfo = data;
            let ids = [];
            data.forEach(element => {
                ids.push(element.id)
            });
            this.form.kaquan_list = ids;
        },
        showCoupons() {
            console.log('show_coupons')
            this.couponsVisible = true
        },
        handleClose(tag) {
            this.sendInfo.splice(this.sendInfo.indexOf(tag), 1);
            let ids = [];
            this.sendInfo.forEach(element => {
                ids.push(element.id)
            });
            this.form.kaquan_list = ids;
            console.log(this.form.kaquan_list);
        },
        changeItems(e) {
            this.zdItemHidden = true
            if (e > 0) {
                this.zdItemHidden = false;
            } else {
                this.form.rel_item_ids = [];
                this.form.rel_item_bns = [];
            }
        },
        getData() {
            getNewCustomerRow(this.$route.query.id)
                .then((response) => {
                    this.form = response.data.data;
                    this.$nextTick(() => {
                        for (let i = 0; i < this.form.items.length; i++) {
                            this.form.items[i].activity_price = this.form.items[i].activity_price/100;
                        }
                        this.relItems = this.form.items;
                        this.addedItems = this.form.items;
                        this.sendInfo = this.form.card_list;
                    })
                })
        },
        onSubmit() {
            if (this.$route.query && this.$route.query.id != undefined) {
                this.edit();
            } else {
                this.save();
            }
        },
        save() {
            const that = this
            saveNewCustomer(this.form)
                .then((response) => {
                    this.$message({
                        type: "success",
                        message: response.data.data.msg,
                        duration: 2000,
                        onClose() {
                            that.refresh()
                            that.$router.go(-1)
                        }
                    });
                })
        },
        edit() {
            const that = this
            editNewCustomer(this.$route.query.id, this.form)
                .then((response) => {
                    this.$message({
                        type: "success",
                        message: response.data.data.msg,
                        duration: 2000,
                        onClose() {
                            that.refresh()
                            that.$router.go(-1)
                        }
                    });
                })
        },
    },
    mounted() {
        if (this.$route.query && this.$route.query.id != undefined) {
            this.getData(this.$route.query.id);
        }
    },
};
</script>
<style scoped lang="scss"></style>
  


// WEBPACK FOOTER //
// edit.vue?bc2df244